"use client";

import React, { useState } from "react";
import { FAQ_ITEMS } from "./constants";

const ChevronIcon = ({ isOpen }: { isOpen: boolean }) => (
  <svg
    className={`h-5 w-5 text-text-secondary transition-transform duration-200 ${
      isOpen ? "rotate-180" : ""
    }`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

function FAQItemComponent({
  item,
  isOpen,
  onToggle,
}: {
  item: FAQItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border border-gray-200 bg-white rounded-xl overflow-hidden">
      <button
        onClick={onToggle}
        className=" p-6 w-full flex items-center justify-between  px-6 py-4 hover:bg-gray-50 transition-colors"
        aria-expanded={isOpen}
      >
        <span className="text-base font-medium text-text-primary text-left">
          {item.question}
        </span>
        <ChevronIcon isOpen={isOpen} />
      </button>
      {isOpen && (
        <div className="px-6 py-4">
          <p className="text-base text-text-secondary leading-relaxed">
            {item.answer}
          </p>
        </div>
      )}
    </div>
  );
}

export function FAQ() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleItem = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-20 bg-section md:py-32 lg:py-40" id="faq">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-5xl text-text-primary mb-5">
            Frequently asked questions
          </h2>
          <p className="text-lg md:text-xl text-text-secondary">
            Everything you need to know about Repayas
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {FAQ_ITEMS.map((item) => (
            <FAQItemComponent
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={() => toggleItem(item.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
